import { allTrackers } from "app/services/track/track";

import createIndustryCodesFilterEventsTrackingService from "./factory";

const industryCodesFilterTrackingService = createIndustryCodesFilterEventsTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default industryCodesFilterTrackingService;
